module.exports = __webpack_public_path__ + "img/dropdown.506031eb.png";